var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { ThemeProvider } from "theme-ui";
import React from "react";
import { Global } from "@emotion/react";
import { jsxs, jsx } from "theme-ui/jsx-runtime";
var button$2 = {
  primary: {
    variant: "text.small",
    px: 3,
    py: 2,
    minHeight: 32,
    display: "inline-flex",
    alignItems: "center",
    flexWrap: "no-wrap",
    justifyContent: "center",
    fontFamily: "body",
    textTransform: "uppercase",
    fontWeight: 500,
    letterSpacing: "0.1px",
    lineHeight: 1.466667,
    cursor: "pointer",
    transition: "background 300ms ease 0s, border 300ms ease 0s, color 300ms ease 0s !important",
    border: "1px solid",
    borderColor: "primary.base",
    color: "text.negative",
    bg: "primary.base",
    borderRadius: "rounded",
    "&:hover": {
      bg: "primary.l1",
      textDecoration: "none"
    },
    "&:disabled": {
      cursor: "not-allowed",
      borderColor: "neutral.l3",
      bg: "neutral.l3",
      color: "neutral.l1"
    },
    "&::-moz-focus-inner": {
      border: 0
    }
  },
  secondary: {
    variant: "buttons.primary",
    color: "primary.base",
    bg: "white",
    borderColor: "primary.base",
    "&:hover": {
      borderColor: "primary.l1",
      bg: "primary.l4"
    },
    "&:disabled": {
      bg: "white",
      borderColor: "neutral.l3",
      color: "neutral.l1"
    }
  },
  ghost: {
    variant: "buttons.primary",
    color: "text.positive",
    borderColor: "transparent",
    bg: "transparent",
    "&:hover": {
      bg: "neutral.l3"
    }
  },
  danger: {
    variant: "buttons.primary",
    color: "text.negative",
    bg: "danger.base",
    borderColor: "danger.base",
    "&:hover": {
      bg: "danger.l1"
    }
  },
  success: {
    variant: "buttons.primary",
    color: "text.negative",
    borderColor: "success.primary",
    bg: "success.d1",
    "&:hover": {
      bg: "success.base"
    }
  }
};
var card$1 = {
  primary: {
    variant: "text.base",
    p: 3,
    fontFamily: "text",
    border: "1px solid",
    borderRadius: "rounded",
    borderColor: "neutral.l3",
    bg: "white"
  },
  float: {
    variant: "cards.primary",
    borderRadius: "lg",
    boxShadow: 1,
    bg: "white"
  },
  focus: {
    variant: "cards.primary",
    borderColor: "primary.l2",
    bg: "primary.l4"
  }
};
var inputContainer$1 = {
  base: {
    variant: "text.base",
    py: 1,
    px: 2,
    minHeight: "32px",
    border: "1px solid",
    bg: "text.negative",
    display: "block",
    borderColor: "neutral.l2",
    borderRadius: "rounded",
    "::-ms-reveal": {
      display: "none"
    },
    "&.read-only": {
      bg: "neutral.l3"
    },
    ":focus": {
      borderColor: "primary.l1"
    },
    "&.input-prefix": {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      borderLeftWidth: 0
    },
    "&.input-suffix": {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      borderRightWidth: 0
    },
    "&.input-has-error": {
      bg: "danger.l2",
      borderColor: "danger.base"
    }
  },
  prefix: {
    variant: "inputContainer.base",
    px: "10px",
    borderTopRightRadius: "none",
    borderBottomRightRadius: "none",
    borderRightWidth: "0px",
    mt: 0,
    borderColor: "neutral.l2",
    "&.input-has-error": {
      bg: "danger.l2",
      borderColor: "danger.base"
    }
  },
  suffix: {
    variant: "inputContainer.prefix",
    borderTopRightRadius: "rounded",
    borderLeftWidth: "0px",
    borderRightWidth: "1px",
    borderBottomRightRadius: "rounded",
    borderTopLeftRadius: "none",
    borderBottomLeftRadius: "none"
  },
  select: {
    variant: "inputContainer.base",
    minHeight: "40px",
    transition: "background 300ms ease 0s, border 300ms ease 0s, color 300ms ease 0s !important",
    bg: "white",
    cursor: "pointer",
    mt: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "&::-moz-focus-inner": {
      border: 0
    },
    "&:hover": {
      bg: "neutral.l4"
    },
    "&.input-has-error:hover": {
      bg: "danger.l15"
    },
    "&:disabled": {
      bg: "neutral.l3",
      cursor: "not-allowed"
    }
  },
  box: {
    mb: 3,
    pb: 1,
    maxWidth: 416,
    border: "none"
  },
  boxError: {
    variant: "inputContainer.box"
  },
  fieldset: {
    m: 0,
    mb: 3,
    p: 0,
    border: "none",
    "& legend": {
      variant: "text.base",
      fontWeight: 500,
      float: "left",
      px: 0
    }
  },
  fieldsetError: {
    variant: "inputContainer.fieldset"
  },
  dropzone: {
    variant: "text.base",
    boxShadow: "menu",
    borderRadius: "rounded",
    border: "1px solid",
    borderColor: "neutral.l3",
    outline: "none",
    bg: "background.card",
    margin: 0,
    listStyleType: "none",
    maxHeight: "20rem",
    overflowY: "auto",
    overflowX: "hidden",
    position: "absolute",
    width: "100%",
    padding: "16px 8px 0"
  },
  listItem: {
    variant: "text.base",
    cursor: "pointer",
    p: 2,
    mx: -2,
    display: "flex",
    alignItems: "center",
    "&.selected": {
      bg: "primary.l3"
    },
    "&.active": {
      bg: "primary.l4"
    }
  },
  description: {
    color: "neutral.base",
    variant: "text.small"
  }
};
var badge$1 = {
  base: {
    variant: "text.micro",
    display: "inline-block",
    borderRadius: "rounded",
    px: 2,
    py: "2px",
    textTransform: "uppercase",
    fontWeight: 600,
    letterSpacing: ".1px",
    maxWidth: "200px",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden"
  },
  neutral: {
    variant: "badge.base",
    bg: "neutral.l3",
    color: "neutral.d2"
  },
  primary: {
    variant: "badge.base",
    bg: "primary.l3",
    color: "primary.d2"
  },
  success: {
    variant: "badge.base",
    bg: "success.l2",
    color: "success.d2"
  },
  danger: {
    variant: "badge.base",
    bg: "danger.l2",
    color: "danger.d2"
  },
  warning: {
    variant: "badge.base",
    bg: "warning.l2",
    color: "warning.d2"
  },
  info: {
    variant: "badge.base",
    bg: "info.l2",
    color: "info.d2"
  }
};
var tag$1 = {
  base: {
    variant: "text.small",
    display: "inline-flex",
    alignItems: "center",
    borderRadius: "full",
    px: 2,
    py: 1,
    "& > div": {
      maxWidth: "150px",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden"
    }
  },
  neutral: {
    variant: "tag.base",
    bg: "neutral.l3",
    "button:hover": {
      bg: "neutral.l2"
    }
  },
  primary: {
    variant: "tag.base",
    bg: "primary.l3",
    "button:hover": {
      bg: "primary.l2"
    }
  }
};
var modal$1 = {
  base: {
    borderRadius: "rounded",
    width: "100%",
    height: "100%",
    position: "absolute",
    left: "50%",
    boxShadow: 5,
    overflow: "auto",
    display: "grid",
    gridTemplateRows: "56px 1fr"
  },
  small: {
    variant: "modal.base",
    maxHeight: ["auto", 336],
    maxWidth: ["auto", 508],
    top: 0,
    "@media (min-width: 40em)": {
      top: 30
    }
  },
  large: {
    variant: "modal.base",
    maxHeight: "auto",
    maxWidth: 856,
    top: 0,
    borderRadius: "none",
    "@media (min-width: 857px)": {
      top: 30,
      maxHeight: 600,
      borderRadius: "rounded"
    }
  },
  extraLarge: {
    variant: "modal.base",
    maxHeight: "calc(100vh - 50px)",
    maxWidth: 1200,
    top: 0,
    borderRadius: "none",
    "@media (min-width: 1201px)": {
      top: 30,
      maxHeight: "auto",
      borderRadius: "rounded"
    }
  },
  full: {
    variant: "modal.base",
    borderRadius: "none",
    top: 0
  }
};
var alert$1 = {
  base: {
    borderRadius: "rounded",
    alignItems: "center",
    columnGap: 3,
    display: "grid",
    p: 2,
    gridTemplateColumns: "25px 1fr",
    "&.on-dismiss": {
      gridTemplateColumns: "25px 1fr 35px"
    }
  },
  inline: {
    variant: "alert.base",
    borderLeft: "4px solid"
  },
  banner: {
    variant: "alert.base",
    fontWeight: 500,
    px: [2, 3],
    py: 3,
    "& a": {
      color: "inherit"
    }
  },
  "banner-warning": {
    variant: "alert.banner",
    color: "text.positive",
    bg: "warning.l15",
    "& svg .color": {
      fill: "warning.d1"
    }
  },
  "banner-info": {
    variant: "alert.banner",
    color: "text.positive",
    bg: "info.l15",
    "& svg .color": {
      fill: "info.d1"
    }
  },
  "banner-danger": {
    variant: "alert.banner",
    color: "text.positive",
    bg: "danger.l15",
    "& svg .color": {
      fill: "danger.d1"
    }
  },
  toast: {
    variant: "alert.base",
    boxShadow: 2,
    bg: "neutral.d1",
    minHeight: 48,
    borderRadius: ["none", "rounded"],
    color: "text.negative",
    fontWeight: 500,
    py: 2,
    px: [2, 3],
    "& .button-dismiss:hover": {
      bg: "neutral.l1"
    }
  }
};
var baseVariants = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  buttons: button$2,
  cards: card$1,
  inputContainer: inputContainer$1,
  badge: badge$1,
  tag: tag$1,
  modal: modal$1,
  alert: alert$1
}, Symbol.toStringTag, { value: "Module" }));
const fontSizes$1 = [
  "0.6875rem",
  "0.75rem",
  "0.875rem",
  "1rem",
  "1.125rem",
  "1.3125rem",
  "1.5rem",
  "2rem"
];
const systemUI$1 = 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif';
const fonts$1 = `Inter, ${systemUI$1}`;
var base$1 = {
  styles: {
    root: {
      body: {
        bg: "background.body",
        variant: "text.base",
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale",
        a: {
          color: "primary.base"
        },
        label: {
          variant: "text.base",
          fontWeight: 500
        },
        "*:focus": {
          outline: ".2rem solid",
          outlineColor: "effects.outline"
        }
      }
    },
    label: {
      variant: "text.base",
      fontWeight: 400
    },
    small: { variant: "text.small" }
  },
  radii: {
    none: 0,
    sm: ".125rem",
    rounded: ".25rem",
    lg: ".5rem",
    full: "9999px"
  },
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fonts: {
    body: fonts$1,
    heading: fonts$1,
    text: fonts$1
  },
  fontSizes: fontSizes$1,
  fontWeights: {
    body: 400,
    heading: 400,
    bold: 700
  },
  lineHeights: {
    body: 1.5,
    heading: 1.2
  },
  text: {
    micro: {
      fontFamily: "body",
      lineHeight: 1.4,
      fontSize: 0
    },
    small: {
      fontFamily: "body",
      lineHeight: 1.46667,
      fontSize: 1
    },
    base: {
      fontFamily: "body",
      color: "text.positive",
      lineHeight: 1.46667,
      fontSize: 2
    },
    h1: {
      fontFamily: "heading",
      py: 3,
      m: 0,
      fontWeight: 600,
      fontSize: 7,
      lineHeight: 1.3333,
      letterSpacing: "-0.8px"
    },
    h2: {
      fontFamily: "heading",
      py: 2,
      m: 0,
      fontWeight: 600,
      fontSize: 6,
      lineHeight: 1.26667,
      letterSpacing: "-0.6px"
    },
    h3: {
      fontFamily: "heading",
      py: 1,
      m: 0,
      fontWeight: 600,
      fontSize: 5,
      lineHeight: 1.25,
      letterSpacing: "-0.4px"
    },
    h4: {
      fontFamily: "heading",
      py: 1,
      m: 0,
      fontWeight: 600,
      fontSize: 4,
      lineHeight: 1.25,
      letterSpacing: "-0.4px"
    },
    h5: {
      fontFamily: "heading",
      py: 1,
      m: 0,
      fontWeight: 600,
      fontSize: 3,
      letterSpacing: ".1px"
    },
    h6: {
      fontFamily: "heading",
      py: 1,
      m: 0,
      fontWeight: 600,
      fontSize: 2,
      lineHeight: 1.25,
      letterSpacing: ".15px"
    }
  }
};
var colors$3 = {
  background: {
    card: "#fff",
    body: "#fff",
    depth: ["#ffffff", "#e5e7eb", "#9fa6b2"]
  },
  logo: {
    icon: "#F58320",
    text: "#717272"
  },
  text: {
    negative: "#ffffff",
    positive: "#323232"
  },
  gradients: {
    primary: "linear-gradient(90deg, #f38221 0%, #eeb420 100%)",
    secondary: "linear-gradient(180deg, #003439 0%, #002528 100%)"
  },
  effects: {
    outline: "rgba(66, 153, 225, 0.5)",
    error: "rgba(198, 42, 21, .5)"
  },
  neutral: {
    d3: "#212121",
    d2: "#323232",
    d1: "#444444",
    base: "#595959",
    l1: "#707070",
    l2: "#a8a8a8",
    l3: "#d7d7d7",
    l4: "#f5f5f5"
  },
  primary: {
    d3: "#003439",
    d2: "#004e55",
    d1: "#006872",
    base: "#00838f",
    l1: "#339ca5",
    l2: "#99cdd2",
    l3: "#cce6e8",
    l4: "#f2f8f9"
  },
  secondary: {
    d3: "#5E3100",
    d2: "#944C00",
    d1: "#CA6800",
    base: "#FF8300",
    l1: "#ff9c33",
    l2: "#ffcd99",
    l3: "#ffe6cc",
    l4: "#fff8f2"
  },
  success: {
    d2: "#24563b",
    d1: "#368169",
    base: "#49ad77",
    l1: "#a4d6bb",
    l15: "#cfe7da",
    l2: "#edf6f1"
  },
  danger: {
    d2: "#6D2219",
    d1: "#A43326",
    base: "#CA4B38",
    l1: "#F05D4D",
    l15: "#F5CFCC",
    l2: "#FAEDEB"
  },
  warning: {
    d2: "#795919",
    d1: "#b68626",
    base: "#f4b334",
    l1: "#f9d999",
    l15: "#fae8c5",
    l2: "#fdf7eb"
  },
  info: {
    d2: "#0e6469",
    d1: "#17979F",
    base: "#1ecad3",
    l1: "#8ee4e9",
    l15: "#caf2f4",
    l2: "#e8f9fa"
  }
};
const shadows$3 = [
  "none",
  "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  "0 25px 50px -12px rgba(0, 0, 0, 0.25)"
];
shadows$3.inner = "inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)";
shadows$3.menu = "0 1px 2px 0 rgba(0, 0, 0, 0.05)";
shadows$3.outline = "0 0 0 4px rgba(66, 153, 225, 0.5)";
shadows$3.error = "0 0 0 3px rgba(198, 42, 21, .5)";
shadows$3.drawer = "-2px 0 3px 0 rgba(0, 0, 0, 0.1), -2px 0 2px 0 rgba(0, 0, 0, 0.06)";
var logo$2 = {
  heroIcon: {
    svg: {
      g: { fill: "white" },
      transform: "scale(3.8)",
      width: 300,
      opacity: 0.11,
      position: "absolute",
      left: -80,
      bottom: 183
    }
  },
  barIcon: {
    svg: {
      g: { fill: "white" },
      width: 172,
      opacity: 0.11,
      position: "absolute",
      left: -20,
      top: -80,
      transform: "scale(3)"
    }
  }
};
var themeVariants$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  logo: logo$2
}, Symbol.toStringTag, { value: "Module" }));
const variants$3 = Object.assign({}, baseVariants, themeVariants$2);
var index$3 = __spreadProps(__spreadValues(__spreadValues({}, variants$3), base$1), {
  colors: colors$3,
  shadows: shadows$3,
  company: "Loanpal",
  url: "http://loanpal.com"
});
var colors$2 = {
  background: {
    card: "#fff",
    body: "#fff",
    depth: ["#ffffff", "#e5e7eb", "#6b7280"]
  },
  logo: {
    icon: "#ddae16",
    text: "#717272"
  },
  text: {
    negative: "hsl(0, 0%, 100%)",
    positive: "#161d2d"
  },
  gradients: {
    primary: "linear-gradient(90deg, #f38221 0%, #eeb420 100%)"
  },
  effects: {
    outline: "rgba(66, 153, 225, 0.5)",
    error: "rgba(198, 42, 21, .5)"
  },
  neutral: {
    d3: "#161d2d",
    d2: "#252f3f",
    d1: "#374151",
    base: "#4b5563",
    l1: "#6b7280",
    l2: "#9fa6b2",
    l3: "#e5e7eb",
    l4: "#f4f5f7"
  },
  primary: {
    d3: "#003439",
    d2: "#004e55",
    d1: "#006872",
    base: "#00838f",
    l1: "#339ca5",
    l2: "#cce6e8",
    l3: "#e6f2f4",
    l4: "#f2f8f9"
  },
  secondary: {
    d3: "#6E4500",
    d2: "#9E5B00",
    d1: "#CF7000",
    base: "#FF8300",
    l1: "#ff9c33",
    l2: "#ffcd99",
    l3: "#ffe6cc",
    l4: "#fff8f2"
  },
  success: {
    d2: "#24563b",
    d1: "#368169",
    base: "#49ad77",
    l1: "#a4d6bb",
    l15: "#cfe7da",
    l2: "#edf6f1"
  },
  danger: {
    d2: "#6d2219",
    d1: "#a43326",
    base: "#ca4b38",
    l1: "#f05d4d",
    l15: "#f5cfcc",
    l2: "#fbeceb"
  },
  warning: {
    d2: "#795919",
    d1: "#b68626",
    base: "#f4b334",
    l1: "#f9d999",
    l15: "#fae8c5",
    l2: "#fdf7eb"
  },
  info: {
    d2: "#0e6469",
    d1: "#16979e",
    base: "#1ecad3",
    l1: "#8ee4e9",
    l15: "#caf2f4",
    l2: "#e8f9fa"
  }
};
const shadows$2 = [
  "none",
  "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  "0 25px 50px -12px rgba(0, 0, 0, 0.25)"
];
shadows$2.inner = "inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)";
shadows$2.menu = "0 1px 2px 0 rgba(0, 0, 0, 0.05)";
shadows$2.outline = "0 0 0 3px rgba(66, 153, 225, 0.5)";
shadows$2.error = "0 0 0 3px rgba(198, 42, 21, .5)";
shadows$2.drawer = "-2px 0 3px 0 rgba(0, 0, 0, 0.1), -2px 0 2px 0 rgba(0, 0, 0, 0.06)";
var logo$1 = {
  heroIcon: {
    svg: {
      g: { fill: "white" },
      transform: "scale(3.8)",
      width: 300,
      opacity: 0.11,
      position: "absolute",
      left: -80,
      bottom: 183
    }
  },
  barIcon: {
    svg: {
      g: { fill: "white" },
      width: 172,
      opacity: 0.11,
      position: "absolute",
      left: -20,
      top: -80,
      transform: "scale(3)"
    }
  }
};
var themeVariants$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  logo: logo$1
}, Symbol.toStringTag, { value: "Module" }));
const variants$2 = Object.assign({}, baseVariants, themeVariants$1);
var index$2 = __spreadProps(__spreadValues(__spreadValues({}, variants$2), base$1), {
  colors: colors$2,
  shadows: shadows$2,
  company: "GivePower",
  url: "http://givepower.org"
});
var colors$1 = {
  background: {
    card: "#fff",
    body: "#fff",
    depth: ["#ffffff", "#e5e7eb", "#9fa6b2"]
  },
  logo: {
    icon: "#F58320",
    text: "#555555"
  },
  text: {
    negative: "#ffffff",
    positive: "#323232"
  },
  gradients: {
    primary: "linear-gradient(90deg, #f38221 0%, #eeb420 100%)",
    secondary: "linear-gradient(180deg, #003439 0%, #002528 100%)"
  },
  effects: {
    outline: "rgba(66, 153, 225, 0.5)",
    error: "rgba(198, 42, 21, .5)"
  },
  neutral: {
    d3: "#212121",
    d2: "#323232",
    d1: "#444444",
    base: "#555555",
    l1: "#707070",
    l2: "#a8a8a8",
    l3: "#d7d7d7",
    l4: "#f5f5f5"
  },
  primary: {
    d3: "#003439",
    d2: "#004e55",
    d1: "#006872",
    base: "#00838f",
    l1: "#339ca5",
    l2: "#99cdd2",
    l3: "#cce6e8",
    l4: "#f2f8f9"
  },
  secondary: {
    d3: "#5E3100",
    d2: "#944C00",
    d1: "#CA6800",
    base: "#FF8300",
    l1: "#ff9c33",
    l2: "#ffcd99",
    l3: "#ffe6cc",
    l4: "#fff8f2"
  },
  success: {
    d2: "#24563b",
    d1: "#368169",
    base: "#49ad77",
    l1: "#a4d6bb",
    l15: "#cfe7da",
    l2: "#edf6f1"
  },
  danger: {
    d2: "#6B0000",
    d1: "#8A0000",
    base: "#AD0000",
    l1: "#EF9393",
    l15: "#F1C3C3",
    l2: "#F5DDDD"
  },
  warning: {
    d2: "#795919",
    d1: "#b68626",
    base: "#F7B334",
    l1: "#f9d999",
    l15: "#fae8c5",
    l2: "#fdf7eb"
  },
  info: {
    d2: "#0D3757",
    d1: "#134E7A",
    base: "#1C70AF",
    l1: "#8DB7D7",
    l15: "#BAD4E7",
    l2: "#E8F0F7"
  }
};
const shadows$1 = [
  "none",
  "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  "0 25px 50px -12px rgba(0, 0, 0, 0.25)"
];
shadows$1.inner = "inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)";
shadows$1.menu = "0 1px 2px 0 rgba(0, 0, 0, 0.05)";
shadows$1.outline = "0 0 0 4px rgba(66, 153, 225, 0.5)";
shadows$1.error = "0 0 0 3px rgba(198, 42, 21, .5)";
shadows$1.drawer = "-2px 0 3px 0 rgba(0, 0, 0, 0.1), -2px 0 2px 0 rgba(0, 0, 0, 0.06)";
var logo = {
  heroIcon: {
    svg: {
      g: { fill: "white" },
      ".icon-gradient": { fill: "white" },
      width: 450,
      opacity: 0.11,
      position: "absolute",
      bottom: 183,
      left: 10,
      display: "none"
    }
  },
  barIcon: {
    svg: {
      g: { fill: "white" },
      ".icon-gradient": { fill: "white" },
      width: 350,
      opacity: 0.11,
      position: "absolute",
      right: 10,
      top: -10,
      display: "none"
    }
  }
};
var button$1 = {
  primary: {
    variant: "text.small",
    px: 3,
    py: 2,
    minHeight: 32,
    display: "inline-flex",
    alignItems: "center",
    flexWrap: "no-wrap",
    justifyContent: "center",
    fontFamily: "body",
    textTransform: "uppercase",
    fontWeight: 500,
    letterSpacing: "0.1px",
    lineHeight: 1.466667,
    cursor: "pointer",
    transition: "background 300ms ease 0s, border 300ms ease 0s, color 300ms ease 0s !important",
    border: "1px solid",
    borderColor: "primary.base",
    color: "text.negative",
    bg: "primary.base",
    borderRadius: "rounded",
    "&:hover": {
      bg: "primary.l1",
      textDecoration: "none"
    },
    "&:disabled": {
      cursor: "not-allowed",
      borderColor: "neutral.l3",
      bg: "neutral.l3",
      color: "neutral.l1"
    },
    "&::-moz-focus-inner": {
      border: 0
    }
  },
  secondary: {
    variant: "buttons.primary",
    color: "primary.base",
    bg: "white",
    borderColor: "primary.base",
    "&:hover": {
      borderColor: "primary.l1",
      bg: "primary.l4"
    },
    "&:disabled": {
      bg: "white",
      borderColor: "neutral.l3",
      color: "neutral.l1"
    }
  },
  ghost: {
    variant: "buttons.primary",
    color: "text.positive",
    borderColor: "transparent",
    bg: "transparent",
    "&:hover": {
      bg: "neutral.l3"
    }
  },
  danger: {
    variant: "buttons.primary",
    color: "text.negative",
    bg: "danger.base",
    borderColor: "danger.base",
    "&:hover": {
      bg: "danger.d1",
      borderColor: "danger.d1"
    }
  },
  success: {
    variant: "buttons.primary",
    color: "text.negative",
    borderColor: "success.primary",
    bg: "success.d1",
    "&:hover": {
      bg: "success.base"
    }
  }
};
var themeVariants = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  logo,
  buttons: button$1
}, Symbol.toStringTag, { value: "Module" }));
const variants$1 = Object.assign({}, baseVariants, themeVariants);
var index$1 = __spreadProps(__spreadValues(__spreadValues({}, variants$1), base$1), {
  colors: colors$1,
  shadows: shadows$1,
  company: "GoodLeap",
  url: "http://goodleap.com"
});
var button = {
  primary: {
    variant: "text.small",
    px: 3,
    py: 2,
    minHeight: 44,
    display: "inline-flex",
    alignItems: "center",
    flexWrap: "no-wrap",
    justifyContent: "center",
    fontFamily: "body",
    fontWeight: 500,
    letterSpacing: "0.1px",
    lineHeight: 1.466667,
    cursor: "pointer",
    fontSize: 2,
    transition: "background 300ms ease 0s, border 300ms ease 0s, color 300ms ease 0s !important",
    color: "text.negative",
    bg: "primary.base",
    borderRadius: "rounded",
    "&:hover": {
      bg: "primary.l1",
      textDecoration: "none"
    },
    "&:disabled": {
      cursor: "not-allowed",
      opacity: ".5"
    },
    "&::-moz-focus-inner": {
      border: 0
    }
  },
  secondary: {
    variant: "buttons.primary",
    color: "primary.base",
    bg: "transparent",
    borderColor: "primary.base",
    borderWidth: 1,
    borderStyle: "solid",
    "&:hover": {
      borderColor: "primary.l1",
      bg: "primary.l4"
    }
  },
  ghost: {
    variant: "buttons.primary",
    color: "text.positive",
    bg: "transparent",
    "&:hover": {
      bg: "neutral.l3"
    }
  },
  danger: {
    variant: "buttons.primary",
    color: "text.negative",
    bg: "danger.base",
    "&:hover": {
      bg: "danger.l1"
    }
  },
  success: {
    variant: "buttons.primary",
    color: "text.negative",
    bg: "success.d1",
    "&:hover": {
      bg: "success.base"
    }
  }
};
var card = {
  primary: {
    variant: "text.base",
    p: 3,
    fontFamily: "text",
    border: "1px solid",
    borderRadius: "rounded",
    borderColor: "neutral.l3"
  },
  float: {
    variant: "cards.primary",
    boxShadow: 1
  },
  focus: {
    variant: "cards.primary",
    borderColor: "primary.l2",
    bg: "primary.l4"
  }
};
var inputContainer = {
  base: {
    variant: "text.base",
    py: 1,
    px: 3,
    fontSize: 2,
    minHeight: 44,
    border: "1px solid",
    bg: "text.negative",
    display: "block",
    borderColor: "neutral.l2",
    borderRadius: "rounded",
    "::-ms-reveal": {
      display: "none"
    },
    "&.read-only": {
      bg: "neutral.l3"
    },
    ":focus": {
      borderColor: "primary.l1"
    },
    "&.input-prefix": {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      borderLeftWidth: 0
    },
    "&.input-suffix": {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      borderRightWidth: 0
    },
    "&.input-has-error": {
      bg: "danger.l2",
      borderColor: "danger.base"
    }
  },
  prefix: {
    variant: "inputContainer.base",
    px: "10px",
    borderTopRightRadius: "none",
    borderBottomRightRadius: "none",
    borderRightWidth: "0px",
    mt: 0,
    pt: "9px",
    borderColor: "neutral.l2",
    "&.input-has-error": {
      bg: "danger.l2",
      borderColor: "danger.base"
    }
  },
  suffix: {
    variant: "inputContainer.prefix",
    borderTopRightRadius: "rounded",
    borderLeftWidth: "0px",
    borderRightWidth: "1px",
    borderBottomRightRadius: "rounded",
    borderTopLeftRadius: "none",
    borderBottomLeftRadius: "none"
  },
  select: {
    variant: "inputContainer.base",
    minHeight: "40px",
    transition: "background 300ms ease 0s, border 300ms ease 0s, color 300ms ease 0s !important",
    bg: "white",
    cursor: "pointer",
    mt: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "&::-moz-focus-inner": {
      border: 0
    },
    "&:hover": {
      bg: "neutral.l4"
    },
    "&.input-has-error:hover": {
      bg: "danger.l15"
    },
    "&:disabled": {
      bg: "neutral.l3",
      cursor: "not-allowed"
    }
  },
  box: {
    mb: 3,
    pb: 1,
    border: "none",
    "& .descriptionInline": {
      ml: 2
    },
    "& .inputImage": {
      mt: 0
    },
    "& .label": {
      ml: 2
    },
    "& .descriptionContainer": {
      mt: -1,
      ml: "28px"
    }
  },
  boxError: {
    variant: "inputContainer.box"
  },
  fieldset: {
    m: 0,
    mb: 3,
    p: 0,
    border: "none",
    "& legend": {
      variant: "text.base",
      fontWeight: 500,
      float: "left",
      px: 0
    },
    "& .inputImage": {
      mt: "2px"
    },
    "& .descriptionContainer": {
      ml: 2
    }
  },
  fieldsetError: {
    variant: "inputContainer.fieldset"
  },
  dropzone: {
    variant: "text.base",
    boxShadow: "menu",
    borderRadius: "rounded",
    border: "1px solid",
    borderColor: "neutral.l3",
    outline: "none",
    bg: "background.card",
    mt: -1,
    listStyleType: "none",
    maxHeight: "20rem",
    overflowY: "auto",
    overflowX: "hidden",
    position: "absolute",
    width: "100%",
    padding: "16px 8px 0"
  },
  listItem: {
    variant: "text.base",
    cursor: "pointer",
    p: 2,
    mx: -2,
    display: "flex",
    alignItems: "center",
    "&.selected": {
      bg: "primary.l3"
    },
    "&.active": {
      bg: "primary.l4"
    }
  },
  description: {
    color: "neutral.base",
    variant: "text.small"
  }
};
var badge = {
  base: {
    variant: "text.micro",
    display: "inline-block",
    borderRadius: "rounded",
    px: 2,
    py: "2px",
    textTransform: "uppercase",
    fontWeight: 600,
    letterSpacing: ".1px",
    maxWidth: "200px",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden"
  },
  neutral: {
    variant: "badge.base",
    bg: "neutral.l3",
    color: "neutral.d2"
  },
  primary: {
    variant: "badge.base",
    bg: "primary.l3",
    color: "primary.d2"
  },
  success: {
    variant: "badge.base",
    bg: "success.l2",
    color: "success.d2"
  },
  danger: {
    variant: "badge.base",
    bg: "danger.l2",
    color: "danger.d2"
  },
  warning: {
    variant: "badge.base",
    bg: "warning.l2",
    color: "warning.d2"
  },
  info: {
    variant: "badge.base",
    bg: "info.l2",
    color: "info.d2"
  }
};
var tag = {
  base: {
    variant: "text.small",
    display: "inline-flex",
    alignItems: "center",
    borderRadius: "full",
    px: 2,
    py: 1,
    "& > div": {
      maxWidth: "150px",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden"
    }
  },
  neutral: {
    variant: "tag.base",
    bg: "neutral.l3",
    "button:hover": {
      bg: "neutral.l2"
    }
  },
  primary: {
    variant: "tag.base",
    bg: "primary.l3",
    "button:hover": {
      bg: "primary.l2"
    }
  }
};
var modal = {
  base: {
    borderRadius: "rounded",
    width: "100%",
    height: "100%",
    position: "absolute",
    left: "50%",
    boxShadow: 5,
    overflow: "auto",
    display: "grid",
    gridTemplateRows: "56px 1fr"
  },
  small: {
    variant: "modal.base",
    maxHeight: ["auto", 336],
    maxWidth: ["auto", 508],
    top: 0,
    "@media (min-width: 40em)": {
      top: 30
    }
  },
  large: {
    variant: "modal.base",
    maxHeight: "auto",
    maxWidth: 856,
    top: 0,
    borderRadius: "none",
    "@media (min-width: 857px)": {
      top: 30,
      maxHeight: 600,
      borderRadius: "rounded"
    }
  },
  extraLarge: {
    variant: "modal.base",
    maxHeight: "calc(100vh - 50px)",
    maxWidth: 1200,
    top: 0,
    borderRadius: "none",
    "@media (min-width: 1201px)": {
      top: 30,
      maxHeight: "auto",
      borderRadius: "rounded"
    }
  },
  full: {
    variant: "modal.base",
    borderRadius: "none",
    top: 0
  }
};
var alert = {
  base: {
    borderRadius: "rounded",
    alignItems: "center",
    columnGap: 3,
    display: "grid",
    p: 2,
    gridTemplateColumns: "25px 1fr",
    "&.on-dismiss": {
      gridTemplateColumns: "25px 1fr 35px"
    }
  },
  inline: {
    variant: "alert.base",
    borderLeft: "4px solid"
  },
  banner: {
    variant: "alert.base",
    fontWeight: 500,
    px: [2, 3],
    py: 3,
    "& a": {
      color: "inherit"
    }
  },
  "banner-warning": {
    variant: "alert.banner",
    color: "text.positive",
    bg: "warning.base",
    "& svg .color": {
      fill: "warning.d2"
    }
  },
  "banner-danger": {
    variant: "alert.banner",
    color: "text.negative",
    bg: "danger.base",
    "& svg .color": {
      fill: "danger.d2"
    }
  },
  toast: {
    variant: "alert.base",
    boxShadow: 2,
    bg: "neutral.d1",
    minHeight: 48,
    borderRadius: ["none", "rounded"],
    color: "text.negative",
    fontWeight: 500,
    py: 2,
    px: [2, 3],
    "& .button-dismiss:hover": {
      bg: "neutral.l1"
    }
  }
};
var variants = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  buttons: button,
  cards: card,
  inputContainer,
  badge,
  tag,
  modal,
  alert
}, Symbol.toStringTag, { value: "Module" }));
const fontSizes = [
  "0.6875rem",
  "0.875rem",
  "1rem",
  "1.125rem",
  "1.25rem",
  "1.3125rem",
  "1.5rem",
  "2rem"
];
const systemUI = 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif';
const fonts = `Inter, ${systemUI}`;
var base = {
  isAccessibleMode: true,
  styles: {
    root: {
      bg: "background.body",
      variant: "text.base",
      WebkitFontSmoothing: "antialiased",
      MozOsxFontSmoothing: "grayscale",
      a: {
        color: "primary.base"
      },
      label: {
        variant: "text.base",
        fontWeight: 500
      },
      "*:focus": {
        outline: ".25rem solid",
        outlineColor: "effects.outline"
      }
    },
    label: {
      variant: "text.base",
      fontWeight: 400
    },
    small: { variant: "text.small" }
  },
  radii: {
    none: 0,
    sm: ".125rem",
    rounded: ".25rem",
    lg: ".5rem",
    full: "9999px"
  },
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fonts: {
    body: fonts,
    heading: fonts,
    text: fonts
  },
  fontSizes,
  fontWeights: {
    body: 400,
    heading: 400,
    bold: 700
  },
  lineHeights: {
    body: 1.5,
    heading: 1.2
  },
  text: {
    micro: {
      fontFamily: "body",
      lineHeight: 1.4,
      fontSize: 0
    },
    small: {
      fontFamily: "body",
      lineHeight: 1.46667,
      fontSize: 1
    },
    base: {
      fontFamily: "body",
      color: "text.positive",
      lineHeight: 1.46667,
      fontSize: 2
    },
    h1: {
      fontFamily: "heading",
      py: 3,
      m: 0,
      fontWeight: 600,
      fontSize: 7,
      lineHeight: 1.3333,
      letterSpacing: "-0.8px"
    },
    h2: {
      fontFamily: "heading",
      py: 2,
      m: 0,
      fontWeight: 600,
      fontSize: 6,
      lineHeight: 1.26667,
      letterSpacing: "-0.6px"
    },
    h3: {
      fontFamily: "heading",
      py: 1,
      m: 0,
      fontWeight: 600,
      fontSize: 5,
      lineHeight: 1.25,
      letterSpacing: "-0.4px"
    },
    h4: {
      fontFamily: "heading",
      py: 1,
      m: 0,
      fontWeight: 600,
      fontSize: 4,
      lineHeight: 1.25,
      letterSpacing: "-0.4px"
    },
    h5: {
      fontFamily: "heading",
      py: 1,
      m: 0,
      fontWeight: 600,
      fontSize: 3,
      letterSpacing: ".1px"
    },
    h6: {
      fontFamily: "heading",
      py: 1,
      m: 0,
      fontWeight: 600,
      fontSize: 2,
      lineHeight: 1.25,
      letterSpacing: ".15px"
    }
  }
};
var colors = {
  background: {
    card: "#fff",
    body: "#fff",
    depth: ["#ffffff", "#e5e7eb", "#9fa6b2"]
  },
  logo: {
    icon: "#F58320",
    text: "#717272"
  },
  text: {
    negative: "hsl(0, 0%, 100%)",
    positive: "#161d2d"
  },
  gradients: {
    primary: "linear-gradient(90deg, #f38221 0%, #eeb420 100%)",
    secondary: "linear-gradient(180deg, #003439 0%, #002528 100%)"
  },
  effects: {
    outline: "rgba(66, 153, 225, 0.5)",
    error: "rgba(198, 42, 21, .5)"
  },
  neutral: {
    d3: "#161d2d",
    d2: "#252f3f",
    d1: "#374151",
    base: "#4b5563",
    l1: "#6b7280",
    l2: "#9fa6b2",
    l3: "#e5e7eb",
    l4: "#f4f5f7"
  },
  primary: {
    d3: "#003439",
    d2: "#004e55",
    d1: "#006872",
    base: "#00838f",
    l1: "#339ca5",
    l2: "#cce6e8",
    l3: "#e6f2f4",
    l4: "#f2f8f9"
  },
  secondary: {
    d3: "#6E4500",
    d2: "#9E5B00",
    d1: "#CF7000",
    base: "#FF8300",
    l1: "#ff9c33",
    l2: "#ffcd99",
    l3: "#ffe6cc",
    l4: "#fff8f2"
  },
  success: {
    d2: "#24563b",
    d1: "#368169",
    base: "#49ad77",
    l1: "#a4d6bb",
    l15: "#cfe7da",
    l2: "#edf6f1"
  },
  danger: {
    d2: "#6d2219",
    d1: "#a43326",
    base: "#ca4b38",
    l1: "#f05d4d",
    l15: "#f5cfcc",
    l2: "#fbeceb"
  },
  warning: {
    d2: "#795919",
    d1: "#b68626",
    base: "#f4b334",
    l1: "#f9d999",
    l15: "#fae8c5",
    l2: "#fdf7eb"
  },
  info: {
    d2: "#0e6469",
    d1: "#16979e",
    base: "#1ecad3",
    l1: "#8ee4e9",
    l15: "#caf2f4",
    l2: "#e8f9fa"
  }
};
const shadows = [
  "none",
  "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  "0 25px 50px -12px rgba(0, 0, 0, 0.25)"
];
shadows.inner = "inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)";
shadows.menu = "0 1px 2px 0 rgba(0, 0, 0, 0.05)";
shadows.outline = "0 0 0 4px rgba(66, 153, 225, 0.5)";
shadows.error = "0 0 0 3px rgba(198, 42, 21, .5)";
shadows.drawer = "-2px 0 3px 0 rgba(0, 0, 0, 0.1), -2px 0 2px 0 rgba(0, 0, 0, 0.06)";
var index = __spreadProps(__spreadValues(__spreadValues({}, variants), base), {
  colors,
  shadows
});
const LumosThemeProvider = (_a) => {
  var _b = _a, {
    children
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  const [sprite, setSprite] = React.useState("");
  React.useEffect(() => {
    fetch("https://d3l0ps0rvdvkbj.cloudfront.net/icons.svg").then((data) => data.text()).then(setSprite);
  }, []);
  return jsxs(ThemeProvider, __spreadProps(__spreadValues({}, props), {
    children: [jsx("div", {
      dangerouslySetInnerHTML: {
        __html: sprite
      }
    }), jsx(Global, {
      styles: {
        ".ReactModal__Overlay, .ReactModal__Overlay--before-close": {
          transition: "opacity 200ms ease-in-out",
          opacity: 0
        },
        ".no-scroll": {
          overflow: "hidden"
        },
        ".modal-drawer .ReactModal__Content > div, .modal-drawer .ReactModal__Content--before-close > div": {
          transition: "all 200ms ease-in-out",
          transform: "translateX(100px)"
        },
        ".lumos-modal .ReactModal__Content > div, .lumos-modal .ReactModal__Content--before-close > div": {
          transition: "all 200ms ease-in-out",
          transform: "translate(-50%, -100px)",
          opacity: 0
        },
        ".ReactModal__Overlay--after-open": {
          opacity: 1
        },
        ".modal-drawer .ReactModal__Content--after-open > div": {
          transform: "translateX(0)"
        },
        ".lumos-modal .ReactModal__Content--after-open > div": {
          transform: "translate(-50%, 0)",
          opacity: 1
        },
        ".ReactModal__Overlay--before-close": {
          opacity: 0
        },
        '*[data-reach-popover=""]': {
          zIndex: 99999
        }
      }
    }), children]
  }));
};
export { index as AccessibleTheme, index$2 as GivePower, index$1 as GoodLeap, index$3 as LumosLight, LumosThemeProvider as default };
